import { useState } from 'react';
import css from './AddCustomer.module.css'; // Reuse existing styles

import * as customerServices from '../../../../services/customerServices';

function AddCustomer({ onAdd, onClose, func = 'Add', data, toggleModal }) {
    const template = {
        customerName: data?.customerName || '',
        customerIsActive: data?.customerIsActive ?? 1,
        customerVAT: data?.customerVAT || '',
        customerNote: data?.customerNote || '',
        customerNameShort: data?.customerNameShort || '',
        customerType: data?.customerType || 'corporate',
    };

    const [newData, setNewData] = useState(template);

    const onChange = (e) => {
        const { id, value } = e.currentTarget;
        setNewData((prev) => ({
            ...prev,
            [id]: id === 'customerIsActive' ? Number(value) : value,
        }));
    };

    const onAddEdit = (e) => {
        e.preventDefault();
        if (func === 'edit') {
            console.log('Editing customer:', newData);
            
            const updateData = newData;
            updateData._id = data.customerId; // Ensure we send the ID for editing
            customerServices
                .edit(updateData)
                .then((res) => {
                    console.log(res);
                    toggleModal();
                    // onAdd(); // Trigger the parent update function
                })
                .catch((err) => {
                    console.error(err);
                });

        } else if (func === 'Add') {
            customerServices
                .create(newData)
                .then((res) => {
                    // onAdd(newData, res.insertId); // Pass new data and new customer ID
                    // onClose(e); // Close the modal after adding
                    // onAdd(); // Trigger the parent update function
                    toggleModal();
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        const dataToSend = {
            ...newData,
            customerIsActive: Number(newData.customerIsActive),
        };

        onAdd(dataToSend);
        setNewData(template); // Reset form after submission
    };
    return (
        <form>
            {func === 'Add' ? <h3>Add new customer</h3> : <h3>Edit customer</h3>}
            <div className={css.formArea}>
                <div className={css.inputs}>
                    <label htmlFor="customerName">
                        Name
                        <input type="text" id="customerName" onChange={onChange} value={newData.customerName} />
                    </label>
                    <label htmlFor="customerNameShort">
                        Short name
                        <input type="text" id="customerNameShort" onChange={onChange} value={newData.customerNameShort} />
                    </label>

                    <label htmlFor="customerVAT">
                        VAT/PIN Number
                        <input type="text" id="customerVAT" onChange={onChange} value={newData.customerVAT} />
                    </label>

                    <label htmlFor="customerType">
                        Type
                        <select id="customerType" onChange={onChange} value={newData.customerType}>
                            <option value={'individual'}>Individual</option>
                            <option value={'corporate'}>Corporate</option>
                        </select>
                    </label>
                    <label htmlFor="customerIsActive">
                        Active
                        <select id="customerIsActive" onChange={onChange} value={newData.customerIsActive}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </label>
                </div>

                <div className={css.textArea}>
                    <label htmlFor="customerNote">Notes</label>
                    <textarea id="customerNote" cols="45" rows="30" onChange={onChange} value={newData.customerNotes} />
                </div>

                <div className={css.buttons}>
                    <button className={func === 'Add' ? css.add : css.edit} onClick={onAddEdit}>
                        {func}
                    </button>
                    <button className={css.close} onClick={e => onClose(e)}>
                        Close
                    </button>
                </div>
            </div>
        </form>
    );
}

export default AddCustomer;
